import React from 'react';
import UsersList from './UsersList';

export default function Users() {
  return (
    <section className="Users">
      <UsersList />
    </section>
  );
}
